import { AfterViewInit, Directive, ElementRef, EventEmitter, HostListener, OnInit, Output } from '@angular/core';

@Directive({
  selector: '[cwSizer]'
})
export class SizerDirective implements OnInit, AfterViewInit {
  @Output() size: EventEmitter<any> = new EventEmitter<any>();

  constructor(private elem: ElementRef) {
    console.log('[SizerDirective]');
  }

  ngOnInit(): void {

  }

  ngAfterViewInit() {
    console.log(this.elem.nativeElement.offsetWidth);

    this.size.emit({
      width: this.elem.nativeElement.offsetWidth,
      height: this.elem.nativeElement.offsetHeight,
    });
  }

  @HostListener('window:resize', ['$event.target'])
  onResize() {
    this.size.emit({
      width: this.elem.nativeElement.offsetWidth,
      height: this.elem.nativeElement.offsetHeight,
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sizer.directive.ts